export const maybeCapitalizeFirstLetter = (label: string | React.ReactNode): string =>
  label && typeof label === 'string'
    ? label.charAt(0).toUpperCase() + label.slice(1)
    : (label as string);
